// extracted by mini-css-extract-plugin
module.exports = {"banner":"_3VXNNcY-sqr0twSqvFwHRd","text":"_3aaUG0zNhzA3y8hN57kXKQ","cta":"_31gVexNGfKqlJ9rHwkbZrL"};